var _g;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconService2 = function SvgIconService2(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    stroke: "#6C5CE7",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#6C5CE7",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.288 42.104c.899 0 1.767-.058 2.589-.166V32.93a19.925 19.925 0 0 0-2.589-.166c-5.13 0-9.288 1.886-9.288 4.213v.913c0 2.327 4.158 4.213 9.288 4.213zM33.288 46.807c.899 0 1.767-.058 2.589-.166v-2.64c-.822.108-1.69.167-2.589.167-4.477 0-8.215-1.437-9.093-3.35a2.055 2.055 0 0 0-.195.863v.913c0 2.327 4.158 4.213 9.288 4.213zM35.877 48.91v-.206c-.822.108-1.69.167-2.589.167-4.478 0-8.215-1.437-9.093-3.35a2.054 2.054 0 0 0-.195.863v.913c0 2.327 4.158 4.213 9.288 4.213 1.026 0 2.013-.076 2.935-.215a3.323 3.323 0 0 1-.346-1.472v-.914zM46.68 25.63c-5.13 0-9.288 1.886-9.288 4.213v.913c0 2.327 4.159 4.213 9.288 4.213 5.13 0 9.288-1.886 9.288-4.213v-.913c0-2.327-4.158-4.213-9.288-4.213z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.68 37.033c-4.477 0-8.215-1.437-9.092-3.35a2.054 2.054 0 0 0-.196.863v.914c0 2.326 4.159 4.212 9.288 4.212 5.13 0 9.288-1.886 9.288-4.212v-.914c0-.296-.067-.584-.195-.863-.878 1.913-4.615 3.35-9.093 3.35z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.68 41.736c-4.477 0-8.215-1.437-9.092-3.35a2.054 2.054 0 0 0-.196.863v.914c0 2.326 4.159 4.212 9.288 4.212 5.13 0 9.288-1.886 9.288-4.212v-.914c0-.296-.067-.584-.195-.863-.878 1.913-4.615 3.35-9.093 3.35z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.68 46.693c-4.477 0-8.215-1.437-9.092-3.35a2.054 2.054 0 0 0-.196.863v.914c0 2.326 4.159 4.212 9.288 4.212 5.13 0 9.288-1.886 9.288-4.212v-.914c0-.296-.067-.584-.195-.863-.878 1.913-4.615 3.35-9.093 3.35z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.68 51.396c-4.477 0-8.215-1.437-9.092-3.35a2.055 2.055 0 0 0-.196.863v.914c0 2.326 4.159 4.213 9.288 4.213 5.13 0 9.288-1.887 9.288-4.213v-.914c0-.296-.067-.584-.195-.863-.878 1.913-4.615 3.35-9.093 3.35z"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconService2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-service-2.955b575b.svg";
export { ForwardRef as ReactComponent };